import { render, staticRenderFns } from "./RecordingReport.vue?vue&type=template&id=894584c8"
import script from "./RecordingReport.vue?vue&type=script&lang=js"
export * from "./RecordingReport.vue?vue&type=script&lang=js"
import style0 from "./RecordingReport.vue?vue&type=style&index=0&id=894584c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports